<script>
import CPTemp1 from "../templates/comparableProject/CPTemp1.vue";
import CPTemp2 from "../templates/comparableProject/CPTemp2.vue";
import CPTemp3 from "../templates/comparableProject/CPTemp3.vue";
import CPTemp4 from "../templates/comparableProject/CPTemp4.vue";
import CPTemp5 from "../templates/comparableProject/CPTemp5.vue";
import CPTemp6 from "../templates/comparableProject/CPTemp6.vue";
import CPTemp7 from "../templates/comparableProject/CPTemp7.vue";
import CPTemp8 from "../templates/comparableProject/CPTemp8.vue";
import CPTemp9 from "../templates/comparableProject/CPTemp9.vue";
import SelectDropdown from "../SelectDropdown.vue";
import store from "@/store";
import StyleBox from "../StyleBox.vue";
import ColorSchemeBox from "../ColorSchemeBox.vue";
import ProjectsDropdown from "../ProjectsDropdown.vue";
import InfoCard from "../InfoCard.vue";
import InputField from "../InputField.vue";
import PreviewTemplates from "../PreviewTemplates.vue";
import { isComparableReady } from "@/utils/proposalValidation";
import { arrowDownIcon, crossIcon } from "@/utils/proposalIcons";
import img1 from "@/assets/images/templates/CPTemp1.png";
import img2 from "@/assets/images/templates/CPTemp2.png";
import img3 from "@/assets/images/templates/CPTemp3.png";
import img4 from "@/assets/images/templates/CPTemp4.png";
import img5 from "@/assets/images/templates/CPTemp5.png";
import img6 from "@/assets/images/templates/CPTemp6.png";
import img7 from "@/assets/images/templates/CPTemp7.png";
import img8 from "@/assets/images/templates/CPTemp8.png";
import img9 from "@/assets/images/templates/CPTemp9.png";
import img10 from "@/assets/images/templates/CPTemp10.png";
import img11 from "@/assets/images/templates/CPTemp11.png";
import img12 from "@/assets/images/templates/CPTemp12.png";
import img13 from "@/assets/images/templates/CPTemp13.png";
import img14 from "@/assets/images/templates/CPTemp14.png";
import img15 from "@/assets/images/templates/CPTemp15.png";
import img16 from "@/assets/images/templates/CPTemp16.png";
import AppButton from "../AppButton.vue";
import CPTemp10 from "../templates/comparableProject/CPTemp10.vue";
import CPTemp11 from "../templates/comparableProject/CPTemp11.vue";
import CPTemp12 from "../templates/comparableProject/CPTemp12.vue";
import CPTemp13 from "../templates/comparableProject/CPTemp13.vue";
import CPTemp14 from "../templates/comparableProject/CPTemp14.vue";
import CPTemp15 from "../templates/comparableProject/CPTemp15.vue";
import CPTemp16 from "../templates/comparableProject/CPTemp16.vue";
import util from "@/utils/util.js";

export default {
    name: "StepComparable",
    components: {
        CPTemp1, CPTemp2, CPTemp3, CPTemp4, CPTemp5, CPTemp6, CPTemp7, CPTemp8, CPTemp9, CPTemp10, CPTemp11, CPTemp12, CPTemp13, CPTemp14, CPTemp15, CPTemp16,
        SelectDropdown,
        StyleBox,
        ColorSchemeBox,
        ProjectsDropdown,
        InfoCard,
        InputField,
        PreviewTemplates,
        AppButton,
    },
    props: {
        proposal: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            prompt: "",
            teamAndFeaturesSection: [1, 2, 5, 7, 9, 10, 11, 12, 13, 16],
            projectTeamSection: [1, 2, 5, 7, 9, 10, 11, 12, 13, 16],
            keyFeaturesSection: [5, 7, 16],
            TemplateList: [
                {
                    label: '1- Display project details and team of 2 projects for comparison each page in horizontal layout',
                    value: 1,
                    preview: img1,
                    orientation: "portrait",
                    style: this.getTemplateStyle(1)
                },
                {
                    label: '2- Display project details and team of 1 project each page',
                    value: 2,
                    preview: img2,
                    orientation: "portrait",
                    style: this.getTemplateStyle(2)
                },
                {
                    label: '3- Display project details of 4 projects for comparison each page in 2x2 grid layout',
                    value: 3,
                    preview: img3,
                    orientation: "portrait",
                    style: this.getTemplateStyle(3)
                },
                {
                    label: '4- Display project details of 2 projects for comparison each page in vertical layout',
                    value: 4,
                    preview: img4,
                    orientation: "portrait",
                    style: this.getTemplateStyle(4)
                },
                {
                    label: '5- Display project details, team and key features with 3 additional images for 1 project each page.',
                    value: 5,
                    preview: img5,
                    orientation: "portrait",
                    style: this.getTemplateStyle(5)
                },
                {
                    label: '6- Display project details with 3 additional images for 2 projects for comparison each page in vertical layout',
                    value: 6,
                    preview: img6,
                    orientation: "portrait",
                    style: this.getTemplateStyle(6)
                },
                {
                    label: '7- Display project key features with 3 additional images for 2 projects for comparison each page in vertical layout',
                    value: 7,
                    preview: img7,
                    orientation: "portrait",
                    style: this.getTemplateStyle(7)
                },
                {
                    label: '8- Display collage of 10-12 projects in a grid layout with an "About section" on top left corner',
                    value: 8,
                    preview: img8,
                    orientation: "portrait",
                    style: this.getTemplateStyle(8)
                },
                {
                    label: '1- Display project details and team on left column and project images on right column for 1 project each page in horizontal layout',
                    value: 9,
                    preview: img9,
                    orientation: "landscape",
                    style: this.getTemplateStyle(9)
                },
                {
                    label: '2- Display project details and team and 1 addintional image on left column and project image on right column for 1 project each page in horizontal layout',
                    value: 10,
                    preview: img10,
                    orientation: "landscape",
                    style: this.getTemplateStyle(10)
                },
                {
                    label: '3- Display project details and team on top section and project image on bottom section for 1 project each page in vertical layout',
                    value: 11,
                    preview: img11,
                    orientation: "landscape",
                    style: this.getTemplateStyle(11)
                },
                {
                    label: '4- Display project image on top section and project details and team on bottom section for 1 project each page in vertical layout',
                    value: 12,
                    preview: img12,
                    orientation: "landscape",
                    style: this.getTemplateStyle(12)
                },
                {
                    label: '5- Display project image on top section and project details and team on bottom section for 1 project each page in vertical layout',
                    value: 13,
                    preview: img13,
                    orientation: "landscape",
                    style: this.getTemplateStyle(13)
                },
                {
                    label: '6- Display 4 projects per page in a 2x2 irregular grid layout with overlaid titles and description boxes',
                    value: 14,
                    preview: img14,
                    orientation: "landscape",
                    style: this.getTemplateStyle(14)
                },
                {
                    label: '7- Display irregular collage grid of 13 projects with an AI-enabled about section.',
                    value: 15,
                    preview: img15,
                    orientation: "landscape",
                    style: this.getTemplateStyle(15)
                },
                {
                    label: '8- Display project details, team, and features on left and 3 images on right column for 1 project each page in horizontal layout',
                    value: 16,
                    preview: img16,
                    orientation: "landscape",
                    style: this.getTemplateStyle(16)
                }
            ],
            expandedProjectId: null,
            expandedBlockId: this.proposal.comparable.blocks && this.proposal.comparable.blocks[0] ? this.proposal.comparable.blocks[0].id : null,
            arrowDownIcon,
            crossIcon,
            store
        };
    },
    computed: {
        previewText() {
            if (!this.proposal.comparable.blocks || this.proposal.comparable.blocks.length === 0) return "Add a block to preview";

            for (let i = 0; i < this.proposal.comparable.blocks.length; i++) {
                const block = this.proposal.comparable.blocks[i];
                const t = block.template;
                const projectsCount = block.projects ? block.projects.length : 0;
                let blockError = "";

                if (t === "" || t === undefined) blockError = `Block ${i + 1}: Select template to preview`;
                else if (t === 2 || t === 5 || t === 16 || t === 9 || t === 10 || t === 11 || t === 12 || t === 13) {
                    if (projectsCount === 0) blockError = `Block ${i + 1}: Select minimum one project to preview`;
                }
                else if (t === 1 || t === 4 || t === 6 || t === 7) {
                    if (projectsCount < 2) blockError = `Block ${i + 1}: Select minimum two projects to preview`;
                }
                else if (t === 3 || t === 14) {
                    if (projectsCount < 4) blockError = `Block ${i + 1}: Select minimum four projects to preview`;
                }
                else if (t === 8 || t === 15) {
                    if (projectsCount == 0) blockError = `Block ${i + 1}: Select minimum one project to preview`;
                    else if (!block.about || !block.about.title) blockError = `Block ${i + 1}: Add title for about section to preview`;
                    else if (!block.about || !block.about.description) blockError = `Block ${i + 1}: Add description for about section to preview`;
                }
                else {
                    blockError = `Block ${i + 1}: Incomplete data for the selected template`;
                }
                if (blockError) return blockError;
            }
            return "";
        },
        isPreviewable() {
            return isComparableReady(this.proposal.comparable);
        }
    },
    watch: {
        proposal: {
            handler(newVal) {
                if (newVal.comparable && !newVal.comparable.blocks) {
                    this.$set(newVal.comparable, 'blocks', [
                        {
                            id: "block_1",
                            template: newVal.comparable.template || "",
                            style: newVal.comparable.style || null,
                            about: newVal.comparable.about || { title: "", description: "" },
                            projects: newVal.comparable.projects || [],
                        }
                    ]);
                }
                if (newVal.comparable && newVal.comparable.blocks) {
                    newVal.comparable.blocks.forEach(block => {
                        block.title = newVal.comparable.title;
                        block.opprName = newVal.comparable.opprName;
                        block.logo = newVal.comparable.logo;
                        block.submittedBy = newVal.comparable.submittedBy;
                        block.city = newVal.comparable.city;
                        block.stateProvince = newVal.comparable.stateProvince;
                        block.contactNo = newVal.comparable.contactNo;
                        block.website = newVal.comparable.website;
                    });
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getTemplateStyle(t) {
            return {
                colorScheme: {
                    header: t == 9 || t == 10 || t == 11 || t == 12 || t == 15 ? "#ffffff" : t == 5 || t == 6 || t == 7 || t == 8 || t == 13 ? "#002b61" : t == 14 ? "#959595" : t == 16 ? "#00be62" : "#545454",
                    body: t == 3 ? "#959595" : t == 8 || t == 15 ? "#4075b9" : "#e3e3e4",
                    footer: t == 5 || t == 6 || t == 7 || t == 8 || t == 11 ? "#002b61" : t == 12 || t == 13 ? "#ffffff" : t == 14 || t == 15 || t == 16 ? "#000000" : "#545454",
                },
                heading: {
                    color: t == 5 || t == 6 || t == 7 ? "#002b61" : t == 9 || t == 10 || t == 11 || t == 12 || t == 14 || t == 15 ? "#000000" : t == 3 || t == 13 ? "#ffffff" : t == 16 ? "#4075b9" : "#004aac",
                    size: t == 3 ? "14" : t == 9 || t == 10 || t == 11 || t == 12 ? "22" : t == 14 ? "40" : t == 15 ? "30" : t == 16 ? "12" : "18",
                    font: "Arial",
                    bold: true,
                    italic: false,
                    underline: false,
                },
                label: {
                    color: t == 3 || t == 8 || t == 15 || t == 13 || t == 14 ? "#ffffff" : "#000000",
                    size: t == 3 ? "14" : "12",
                    font: "Arial",
                    bold: true,
                    italic: false,
                    underline: false,
                },
                text: {
                    color: t == 3 || t == 8 || t == 15 || t == 13 || t == 14 ? "#ffffff" : "#000000",
                    size: t == 3 ? "14" : "12",
                    font: "Arial",
                    bold: false,
                    italic: false,
                    underline: false,
                },
            };
        },
        fixStyling(block) {
            const match = this.TemplateList.find(item => item.value === block.template);
            if (match) block.style = match.style;
        },
        async summarizeProject(project, block) {
            const t = block.template;
            if (t !== 14) return;

            const id = project.projectId;
            const type = "project";
            const limit = 100;

            if (project.projectDetails && project.projectDetails.length <= limit) return;

            const cached = store.state.aiResponses[`${type}-${id}`];
            if (cached && cached.length <= limit) {
                project.projectDetails = cached;
                return;
            }

            let promptText = "";
            const currentDetails = project.projectDetails || "";
            if (currentDetails.length > limit) {
                promptText = `Summarize the following project details for the project "${project.projectName}" to be close to and maximum ${limit} characters while maintaining a professional, objective tone: ${currentDetails}`;
            } else {
                promptText = `Write a concise project scope description for the project "${project.projectName}". In 1–2 professional sentences (maximum ${limit} characters), describe the scope of work the team was responsible for, including key objectives, responsibilities, and outcomes. Keep the tone factual and objective, suitable for a resume or project experience section. Avoid marketing language, promotional wording, headings, or exaggerated claims.`;
            }

            try {
                const response = await store.dispatch("generateAIResponseById", { type, id, prompt: promptText });
                if (response) {
                    project.projectDetails = response;
                }
            } catch (error) {
                console.error("AI Generation failed for project:", id, error);
            }
        },
        handleTemplateSelection(selectedTemplate, block) {
            block.template = selectedTemplate;
            if ((selectedTemplate === 8 || selectedTemplate === 15) && (!block.about || !block.about.title)) {
                this.$set(block, 'about', {
                    title: '',
                    description: '',
                    prompt: ''
                });
            }
            this.fixStyling(block);
        },
        handleProjectSelection(projects, block) {
            const updatedProjects = projects.map(p => {
                return { ...p };
            });

            const oldIds = new Set((block.projects || []).map(p => p.projectId));
            block.projects = updatedProjects;

            if (block.template === 14) {
                updatedProjects.forEach(project => {
                    if (!oldIds.has(project.projectId)) {
                        this.summarizeProject(project, block);
                    }
                });
            }
        },
        toggleProject(id) {
            this.expandedProjectId = this.expandedProjectId === id ? null : id;
        },
        handleMemberSelection(selectedIds, project, block) {
            if (project.assignedTeamMembers) {
                project.projectTeam = selectedIds.map(id => {
                    const existing = (project.projectTeam || []).find(m => m.teamMemberId === id);
                    if (existing) return existing;

                    const m = project.assignedTeamMembers.find(member => member.teamMemberId === id);
                    if (m) {
                        return {
                            teamMemberId: m.teamMemberId,
                            name: m.teamMemberName,
                            role: m.role || "Team Member",
                            profilePicturePath: m.profilePicturePath
                        };
                    }
                    return null;
                }).filter(Boolean);

                block.projects = [...block.projects];
            }
        },
        removeMember(id, project, block) {
            project.projectTeam = (project.projectTeam || []).filter(m => m.teamMemberId !== id);
            block.projects = [...block.projects];
        },
        moveMember({ from, to }, project, block) {
            const list = [...(project.projectTeam || [])];
            if (from < 0 || to < 0 || from >= list.length || to >= list.length) return;
            const [moved] = list.splice(from, 1);
            list.splice(to, 0, moved);
            project.projectTeam = list;
            block.projects = [...block.projects];
        },
        addFeature(project, block) {
            if (!project.newFeatureText || !project.newFeatureText.trim()) return;
            if (!project.keyFeatures) this.$set(project, 'keyFeatures', []);
            project.keyFeatures.push(project.newFeatureText.trim());
            this.$set(project, 'newFeatureText', '');
            block.projects = [...block.projects];
        },
        updateProjectsList(block) {
            block.projects = [...block.projects];
        },
        removeFeature(project, index, block) {
            if (project.keyFeatures) {
                project.keyFeatures.splice(index, 1);
                block.projects = [...block.projects];
            }
        },
        async handleGenerateResponse(promptText, block) {
            if (!promptText || !promptText.trim()) return;
            try {
                const aiPrompt = `Write a clear, detailed, and professional response of 2-3 lines to the following: "${promptText}". Provide a single, continuous paragraph that directly addresses the topic. The response should be suitable for inclusion in a professional proposal, demonstrating technical understanding, accountability, and attention to quality. Maintain a factual and objective tone, avoiding headings, bullet points, numbered lists, marketing language, generic statements, or exaggerated claims. Focus on clarity, precision, and professionalism.`;
                const response = await store.dispatch("generateAIResponse", aiPrompt);
                if (response) {
                    if (!block.about) this.$set(block, 'about', {});
                    this.$set(block.about, 'description', response);
                }
            } catch (error) {
                console.error("Failed to generate response:", error);
            }
        },
        addBlock() {
            if (!this.proposal.comparable.blocks) {
                this.$set(this.proposal.comparable, 'blocks', []);
            }
            const newBlock = {
                id: `block_${Date.now()}`,
                template: "",
                style: null,
                about: { title: "", description: "" },
                projects: []
            };
            this.proposal.comparable.blocks.push(newBlock);
            this.expandedBlockId = newBlock.id;
        },
        removeBlock(index) {
	        let content = {
		      titleText: 'Confirm Delete',
		      message1: `Are you sure you want to remove the block?`		
	         };
	        let cm = util.fn_getModal_confirm(this, content);

	        this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
		    if (!resp) return;
                this.proposal.comparable.blocks.splice(index, 1);
          });
    }
    }
};
</script>


<template>
  <div class="d-flex flex-column w-100 bg-white rounded-lg text-left">
    <div class="d-flex flex-column">
      <h4 class="mb-3 font-weight-bold">Comparable Projects</h4>

      <div class="row">
        <div class="col-12 mb-3">
          <InputField label="Section Title" :modelValue="proposal.comparable.title" placeholder="Enter Section Title"
            @update:modelValue="proposal.comparable.title = $event" />
        </div>
      </div>

      <div v-for="(block, bIdx) in proposal.comparable.blocks" :key="block.id || bIdx"
        class="block-container border mb-4 rounded">
        <div class="d-flex justify-content-between align-items-center p-3 cursor-pointer bg-light"
          @click="expandedBlockId = (expandedBlockId === block.id ? null : block.id)">
          <h5 class="mb-0 font-weight-bold">Template Block {{ bIdx + 1 }}</h5>

          <div class="d-flex align-items-center justify-content-center">
            <AppButton v-if="proposal.comparable.blocks && proposal.comparable.blocks.length > 1" variant="danger" size="sm"
              @click.stop="removeBlock(bIdx)" class="btn-delete" variant="danger" title="Remove block">
              <fa-icon icon="trash-alt" />
            </AppButton>

            <span class="expanded-icon"
              :style="{ transform: expandedBlockId === block.id ? 'rotate(180deg)' : 'rotate(0deg)' }">
              <span v-html="arrowDownIcon"></span>
            </span>
          </div>
        </div>

        <div v-show="expandedBlockId === block.id" class="p-3 border-top">

          <div class="row">
            <div class="col-12 mb-3">
              <SelectDropdown label="Template" :modelValue="block.template"
                :options="TemplateList.filter(item => item.orientation === proposal.pageOrientation)"
                placeholder="Select Template" @update:modelValue="(val) => handleTemplateSelection(val, block)"
                :isPreviewable="true" />
            </div>
          </div>

          <div v-if="block.template" class="row">
            <div class="col-12 col-md-6 mb-3">
              <ProjectsDropdown label="Projects" :modelValue="block.projects"
                :isAI="block.template !== 3 && block.template !== 7 && block.template !== 8 && block.template !== 15"
                :textLimit="block.template === 10 ? 1600 : block.template === 1 || block.template === 2 || block.template === 4 || block.template === 11 || block.template === 12 || block.template === 16 ? 1300 : block.template === 6 ? 1000 : block.template === 9 ? 2000 : block.template === 13 ? 900 : block.template === 14 ? 150 : 2500"
                @update:modelValue="(val) => handleProjectSelection(val, block)" :disabled="!block.template"
                context="comparable" />
            </div>

            <div class="col-12 col-md-6 mb-3"
              v-if="teamAndFeaturesSection.includes(block.template) && block.projects && block.projects.length > 0">
              <p class="label mt-40 mb-2">Project Details</p>
              <div class="d-flex flex-column gap-4">
                <div class="project-trigger bg-white" v-for="project in block.projects" :key="project.projectId">
                  <div class="d-flex justify-content-between align-items-center" role="button"
                    @click="toggleProject(project.projectId)">
                    <p class="project-name-sidebar">{{ project.projectName }}</p>
                    <span v-html="arrowDownIcon" class="searchable-dropdown-arrow"
                      :class="{ open: expandedProjectId === project.projectId }" />
                  </div>
                  <div class="border-top mt-1 pt-2" v-show="expandedProjectId === project.projectId">
                    <div class="mb-3" v-if="projectTeamSection.includes(block.template)">
                      <p class="font-weight-bolder mb-1">Project Team:</p>
                      <SelectDropdown :modelValue="(project.projectTeam || []).map(m => m.teamMemberId)"
                        :options="project.assignedTeamMembers ? project.assignedTeamMembers.map(m => ({ label: m.teamMemberName, value: m.teamMemberId })) : []"
                        :multi="true" placeholder="Select Team Members" :maxSelection="5"
                        @update:modelValue="(ids) => handleMemberSelection(ids, project, block)" />

                      <div v-if="project.projectTeam && project.projectTeam.length > 0" class="mt-2">
                        <InfoCard :list="project.projectTeam" idKey="teamMemberId" labelKey="name"
                          @remove-item="(id) => removeMember(id, project, block)"
                          @move-item="(moveData) => moveMember(moveData, project, block)"
                          @update="(newList) => { project.projectTeam = newList; block.projects = [...block.projects]; }" />
                      </div>
                    </div>

                    <div v-if="keyFeaturesSection.includes(block.template)">
                      <p class="font-weight-bolder mb-1">Key Features</p>
                      <div class="d-flex align-items-center mb-2 gap-4">
                        <InputField
                          :key="project.projectId + '-' + ((project.keyFeatures && project.keyFeatures.length) || 0)"
                          type="text" placeholder="Add a key feature" :modelValue="project.newFeatureText || ''"
                          @update:modelValue="project.newFeatureText = $event" />
                        <AppButton variant="primary" @click="addFeature(project, block)">
                          Add
                        </AppButton>
                      </div>
                      <div class="d-flex flex-column gap-4 p-0 m-0">
                        <div v-for="(feature, fIdx) in project.keyFeatures || []" :key="fIdx" class="feature-item">
                          <input type="text" class="feature-input" v-model="project.keyFeatures[fIdx]"
                            @blur="() => updateProjectsList(block)" />
                          <button class="remove-btn" @click="removeFeature(project, fIdx, block)"><span
                              v-html="crossIcon"></span></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="block.template && block.template == 8 || block.template == 15" class="row">
            <div class="col-12 mb-3">
              <p class="label">About Section</p>
              <div class="row">
                <div class="col-12 mb-1">
                  <InputField :modelValue="block.about && block.about.title" placeholder="Enter Title"
                    @update:modelValue="(val) => { if (!block.about) block.about = {}; block.about.title = val; }"
                    :disabled="store.state.loading.aiGenerate || block.template !== 8 && block.template !== 15" />
                </div>
              </div>
              <div class="d-flex align-items-center mb-1">
                <InputField :modelValue="prompt" placeholder="Enter Prompt" @update:modelValue="prompt = $event"
                  :disabled="store.state.loading.aiGenerate || block.template !== 8 && block.template !== 15" />
                <AppButton
                  :disabled="store.state.loading.aiGenerate || !prompt.trim() || block.template !== 8 && block.template !== 15"
                  @click="handleGenerateResponse(prompt, block)" variant="primary" size="sm" class="ml-1">
                  {{ store.state.loading.aiGenerate ? 'Generating' : 'Generate' }}
                </AppButton>
              </div>
              <InputField :isTextarea="true" :modelValue="block.about && block.about.description"
                placeholder="Generate or enter description..."
                @update:modelValue="(val) => { if (!block.about) block.about = {}; block.about.description = val; }"
                :disabled="store.state.loading.aiGenerate || block.template !== 8 && block.template !== 15" />
            </div>
          </div>

          <div class="row" v-if="block.template && block.style">
            <div v-for="item in [
              { key: 'colorScheme', label: 'Color Scheme' },
              { key: 'heading', label: 'Heading Color', disabled: block.template === 8 },
              { key: 'label', label: 'Label Color' },
              { key: 'text', label: 'Text Color' }
            ]" :key="item.key" class="col-12 col-md-6 col-lg-3 mb-3">
              <ColorSchemeBox v-if="item.key === 'colorScheme'" :styling="block.style[item.key]" :label="item.label" />
              <StyleBox v-else :styling="block.style[item.key]" :label="item.label" :disabled="item.disabled" />
            </div>
          </div>
        </div>
      </div>

      <div class="mb-4 d-flex justify-content-center">
        <AppButton  variant="none" class="btn-add-pill icon" title="Add a block" @click="addBlock()">
          <fa-icon icon="plus" style="color:green;" />Add a block
        </AppButton>
      </div>

    </div>

    <PreviewTemplates :isPreviewable="isPreviewable" :emptyMessage="previewText">
      <div v-for="(block, bIdx) in proposal.comparable.blocks" :key="block.id || bIdx"
        class="comparable-preview-wrapper">
        <CPTemp1 v-if="block.template === 1 && block.projects && block.projects.length >= 2" :projects="block" />
        <CPTemp2 v-if="block.template === 2 && block.projects && block.projects.length > 0" :projects="block" />
        <CPTemp3 v-if="block.template === 3 && block.projects && block.projects.length >= 4" :projects="block" />
        <CPTemp4 v-if="block.template === 4 && block.projects && block.projects.length >= 2" :projects="block" />
        <CPTemp5 v-if="block.template === 5 && block.projects && block.projects.length > 0" :projects="block" />
        <CPTemp6 v-if="block.template === 6 && block.projects && block.projects.length >= 2" :projects="block" />
        <CPTemp7 v-if="block.template === 7 && block.projects && block.projects.length >= 2" :projects="block" />
        <CPTemp8 v-if="block.template === 8 && block.projects && block.projects.length > 0" :projects="block" />
        <CPTemp9 v-if="block.template === 9 && block.projects && block.projects.length > 0" :projects="block" />
        <CPTemp10 v-if="block.template === 10 && block.projects && block.projects.length > 0" :projects="block" />
        <CPTemp11 v-if="block.template === 11 && block.projects && block.projects.length > 0" :projects="block" />
        <CPTemp12 v-if="block.template === 12 && block.projects && block.projects.length > 0" :projects="block" />
        <CPTemp13 v-if="block.template === 13 && block.projects && block.projects.length > 0" :projects="block" />
        <CPTemp14 v-if="block.template === 14 && block.projects && block.projects.length >= 4" :projects="block" />
        <CPTemp15 v-if="block.template === 15 && block.projects && block.projects.length > 0" :projects="block" />
        <CPTemp16 v-if="block.template === 16 && block.projects && block.projects.length > 0" :projects="block" />
      </div>
    </PreviewTemplates>
  </div>
</template>

<style scoped lang="scss">
.label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
}

.mt-40 {
  margin-top: 45px;
}

.gap-4 {
  gap: 4px;
}

.project-trigger {
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  font-size: 13px;
  padding: 4px 10px;
  margin: 0px;

  .project-name-sidebar {
    margin: 5.25px 0px;
    font-weight: 500;
  }
}

.searchable-dropdown-arrow {
  margin-left: 8px;
  transition: transform 0.2s;
  font-size: 12px;
  padding: 2px 0px;
  color: #999;
  flex-shrink: 0;

  &.open {
    transform: rotate(180deg);
  }
}

.feature-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 10px;
  border-radius: 6px;
  background: #f8f9fa;
  border: 1px solid #e2e2e2;
}

.feature-input {
  font-size: 13px;
  border: none;
  background: transparent;
  box-shadow: none;
  width: 100%;
  height: 35.34px;
  outline: none;
}

.remove-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  color: #999;
  padding: 4px;
  font-size: 18px;
  cursor: pointer;
  flex-shrink: 0;
  height: 24px;

  &:hover {
    color: #ff4444;
  }
}

.comparable-preview-wrapper {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0px;
  }
}

.cursor-pointer {
  cursor: pointer;
}

.expanded-icon {
  display: inline-flex;
  transition: transform 0.3s ease;
  align-items: center;
  margin-left: 10px;
  justify-content: center;
}

.gap-20 {
  gap: 20px;
}
.btn-delete {
    color: #dc3545;
    text-align: center;
    font-size: 0.8em;
    width: 23px;
    padding: 0.1em 0;
    margin: 0.25em 0;
    margin-left: 0.5em;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: color 0.2s ease, transform 0.15s ease;
}

.btn-delete:hover {
    color: #a71d2a;        /* slightly darker red */
    text-decoration: underline;
    transform: scale(1.15); /* subtle emphasis */
}
.btn-add-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  background: #e8f8ee;
  border: none;
  border-radius: 50px;
  font-size: 14px;
  color: #1f7a3a;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-add-pill .icon {
  font-size: 16px;
  font-weight: bold;
}

.btn-add-pill:hover {
  background: #dff5e7;
}
</style>
